import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';


import { AllPlatformConfigs,ListResponseModel, ListRuquestModel } from './models';

export const getFieldConfigs = async (): Promise<AllPlatformConfigs> => {
  return await AxiosInstance.get(`${API_URL}/smartGroups/fieldConfigs`);
};

export const getSmartGroups = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/smartGroups`, { params });
}

export const addOrUpdateSmartGroup = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/smartGroups`, { ...params });
}

export const deleteSmartGroup = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/smartGroups/${id}`);
}

export const syncSmartGroup = (id: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/smartGroups/${id}/sync`);
}